import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { TelecallerMasterService } from '../../../services/index';

@Component({
    selector: 'add-edit-telecaller-window',
    templateUrl: './addEditTelecaller.component.html'
})
export class AddEditTelecallerComponent implements OnInit {
    @Output() telecallerUpdateEvent = new EventEmitter();

    title: string;
    telecallerdata: any = {};
    isLoading = false;

    followupTeamList: any[] = [];
    employeeList: any[] = [];
    slotList: any[] = [];
    statusList = ['Active', 'InActive'];

    empSearchTimeout: any;
    empDropdownPos: any = null;

    constructor(
        public bsModalRef: BsModalRef,
        private telecallerMasterService: TelecallerMasterService,
        private toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.loadFollowupTeams();
        this.loadSlotList();
    }

    loadFollowupTeams(): void {
        this.telecallerMasterService.getFollowupTeamList().then((res: any) => {
            if (res.success) {
                this.followupTeamList = res.data;
                setTimeout(() => {
                    if (this.telecallerdata['followup_team_id']) {
                        const match = res.data.find((t: any) => t.followup_team_id == this.telecallerdata['followup_team_id']);
                        if (match) { this.telecallerdata['team_name_display'] = match.team_name; }
                    }
                }, 0);
            }
        });
    }

    onSelectTeam(team: any): void {
        this.telecallerdata['followup_team_id'] = team.followup_team_id;
        this.telecallerdata['team_name_display'] = team.team_name;
    }

    loadSlotList(): void {
        this.telecallerMasterService.getSlotList().then((res: any) => {
            if (res.success) { this.slotList = res.data; }
        });
    }

    onEmpFocus(event: any): void {
        const rect = event.target.getBoundingClientRect();
        this.empDropdownPos = { top: rect.bottom + 2, left: rect.left, width: rect.width };
    }

    onEmpBlur(): void {
        setTimeout(() => { this.employeeList = []; this.empDropdownPos = null; }, 200);
    }

    onEmployeeSearch(event: any): void {
        const rect = event.target.getBoundingClientRect();
        this.empDropdownPos = { top: rect.bottom + 2, left: rect.left, width: rect.width };
        let term = event.target.value;
        if (this.empSearchTimeout) { clearTimeout(this.empSearchTimeout); }
        if (!term || term.length < 2) { this.employeeList = []; return; }
        this.empSearchTimeout = setTimeout(() => {
            this.telecallerMasterService.getEmployeeList(term).then((res: any) => {
                if (res.success) { this.employeeList = res.data; }
            });
        }, 300);
    }

    onSelectEmployee(emp: any): void {
        this.telecallerdata['empid'] = emp.empid;
        this.telecallerdata['emp_display'] = emp.emp_display;
        this.employeeList = [];
        this.empDropdownPos = null;
    }

    onSave(): void {
        let toast: any = { type: 'warning', title: 'WARNING' };

        if (!this.telecallerdata['followup_team_id']) {
            toast['body'] = 'Please Select Followup Team';
            this.toasterService.pop(toast); return;
        }
        if (!this.telecallerdata['telecaller_slot']) {
            toast['body'] = 'Please Select Telecaller Slot';
            this.toasterService.pop(toast); return;
        }
        if (_.isEmpty(_.toString(this.telecallerdata['username']))) {
            toast['body'] = 'Please Enter Username';
            this.toasterService.pop(toast); return;
        }
        if (_.isEmpty(_.toString(this.telecallerdata['password']))) {
            toast['body'] = 'Please Enter Password';
            this.toasterService.pop(toast); return;
        }
        if (_.isEmpty(_.toString(this.telecallerdata['fullname']))) {
            toast['body'] = 'Please Enter Full Name';
            this.toasterService.pop(toast); return;
        }
        if (_.isEmpty(_.toString(this.telecallerdata['mobile']))) {
            toast['body'] = 'Please Enter Mobile';
            this.toasterService.pop(toast); return;
        }
        if (!this.telecallerdata['status']) {
            toast['body'] = 'Please Select Status';
            this.toasterService.pop(toast); return;
        }
        if (!this.telecallerdata['empid']) {
            toast['body'] = 'Please Select Employee Name';
            this.toasterService.pop(toast); return;
        }

        let data = {
            mode:                 this.telecallerdata['mode'],
            userid:               this.telecallerdata['userid'] || '',
            followup_team_id:     this.telecallerdata['followup_team_id'],
            telecaller_slot:      this.telecallerdata['telecaller_slot'],
            username:             this.telecallerdata['username'],
            password:             this.telecallerdata['password'] || '',
            fullname:             this.telecallerdata['fullname'],
            mobile:               this.telecallerdata['mobile'],
            empid:                this.telecallerdata['empid'] || '',
            status:               this.telecallerdata['status'],
            user_mac_address_1:   this.telecallerdata['user_mac_address_1']  || '',
            user_mac_address_2:   this.telecallerdata['user_mac_address_2']  || '',
            user_mac_address_3:   this.telecallerdata['user_mac_address_3']  || '',
            user_mac_address_4:   this.telecallerdata['user_mac_address_4']  || '',
            user_mac_address_5:   this.telecallerdata['user_mac_address_5']  || '',
            user_mac_address_6:   this.telecallerdata['user_mac_address_6']  || '',
            user_mac_address_7:   this.telecallerdata['user_mac_address_7']  || '',
            user_mac_address_8:   this.telecallerdata['user_mac_address_8']  || '',
            user_mac_address_9:   this.telecallerdata['user_mac_address_9']  || '',
            user_mac_address_10:  this.telecallerdata['user_mac_address_10'] || '',
            is_mac_address_enable: this.telecallerdata['is_mac_address_enable'] ? 'Yes' : 'No'
        };

        this.isLoading = true;
        this.telecallerMasterService.addUpdateTelecaller(data)
            .then((res: any) => {
                this.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    this.bsModalRef.hide();
                    this.telecallerUpdateEvent.emit();
                } else {
                    swal('Warning', res.message, 'warning');
                }
            })
            .catch((err: any) => {
                this.isLoading = false;
                swal('ERROR', 'Something went wrong', 'error');
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/telecallerMaster/addEditTelecaller.component.ts